import { FC, memo } from "react";
import { Trans } from "react-i18next";
import CardanoExplorer from "../../../../components/CardanoExplorer";
import { CARDANO_EXPLORER_LINK_MAP } from "../../../../constants/cardano.constants";
import { useProfileAppContext } from "../../../../stores";

interface ITasteTestVerificationTooltipProps {
  txHash: string;
}

const TasteTestVerificationTooltip: FC<ITasteTestVerificationTooltipProps> = ({ txHash }) => {
  const {
    state: { cardanoExplorer },
  } = useProfileAppContext();

  return (
    <Trans i18nKey="detail.badges.verified" ns="taste-test">
      This Taste Test is verified. The Transaction that officially created this Taste Test:{" "}
      <CardanoExplorer
        hash={txHash}
        type={CARDANO_EXPLORER_LINK_MAP.transaction[cardanoExplorer]}
        size="xs"
      />
    </Trans>
  );
};

export default memo(TasteTestVerificationTooltip);
